export default __webpack_public_path__ + "static/media/Arch_Amazon-Elastic-Block-Store_64.1dd3ba0f.svg";